import { atom } from "recoil"
import { ATOMS_KEYS } from "../atom-keys"

export const searchByPropertyName = atom<string | undefined>({
	key: ATOMS_KEYS.SEARCHBYNAME,
	default: undefined,
})
